module.exports = __webpack_public_path__ + "static/media/winter_discovery_pack_cat_FR.eb60c103.png";